__turbopack_context__.v({
  "aside": "exhibition-theme-module-scss-module__Rs-BJW__aside",
  "exhibition-theme__svg-wrapper": "exhibition-theme-module-scss-module__Rs-BJW__exhibition-theme__svg-wrapper",
  "exhibition-theme__text": "exhibition-theme-module-scss-module__Rs-BJW__exhibition-theme__text",
  "exhibitionTheme": "exhibition-theme-module-scss-module__Rs-BJW__exhibitionTheme",
  "main": "exhibition-theme-module-scss-module__Rs-BJW__main",
  "shelf": "exhibition-theme-module-scss-module__Rs-BJW__shelf",
  "sliderWrapper": "exhibition-theme-module-scss-module__Rs-BJW__sliderWrapper",
  "subtitle": "exhibition-theme-module-scss-module__Rs-BJW__subtitle",
  "title": "exhibition-theme-module-scss-module__Rs-BJW__title",
});
